import React from 'react';

import { FormattedCurrency } from '@/helpers/i18n';

import * as S from './slider-mark-label.styles';

type MarkLabelProps = { value: number; isDisabled?: boolean };

export const SliderMarkLabel: React.VFC<MarkLabelProps> = ({ value, isDisabled }) => {
  return (
    <S.MarkLabel size="medium" noMargin $isDisabled={isDisabled}>
      <FormattedCurrency value={value} currency="EUR" />
    </S.MarkLabel>
  );
};
